import Icon from '../components/Icon.vue'

Icon.register({
  'chart-pie': {
    width: 544,
    height: 512,
    paths: [
      {
        d: 'M527.8 288c9.5 0 17.4 8.4 16.1 17.8-7.8 55.3-34.4 104.4-73.1 140.9-6.2 5.8-16.1 5.4-22.2-0.7l-158-158h237.3zM512 223.2c0.6 9.1-7 16.8-16.2 16.8h-223.8v-223.8c0-9.1 7.7-16.8 16.8-16.2 119.5 8.2 214.9 103.7 223.2 223.2zM224 288l155.9 155.9c6.8 6.8 6.3 18.5-1.6 24.1-38.3 27.2-84.9 43.4-135.3 44-128.2 1.6-238.5-103.5-242.9-231.6-4.2-124.8 86.9-228.9 206-245.7 9.5-1.3 17.8 6.5 17.8 16.1v237.3z'
      }
    ]
  }
})
